var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFailedPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_failed_payment",
    d: "M210.425,478.9v-.888a1.825,1.825,0,0,0-1.808-1.84H195.7a1.825,1.825,0,0,0-1.808,1.84h0v.888a.164.164,0,0,0,.161.164h16.213A.163.163,0,0,0,210.425,478.9Zm.118,4.265a4.54,4.54,0,0,0-3.257-1.371h0a4.541,4.541,0,0,0-3.259,1.377,4.753,4.753,0,0,0,.005,6.633,4.558,4.558,0,0,0,6.514,0A4.766,4.766,0,0,0,210.543,483.166Zm-.784,4.487a.971.971,0,0,1,0,1.355.93.93,0,0,1-1.331,0l-1.146-1.167-1.147,1.167a.93.93,0,0,1-1.331,0,.971.971,0,0,1,0-1.355l1.146-1.167-1.147-1.167a.971.971,0,0,1,0-1.355.932.932,0,0,1,1.331,0l1.148,1.167,1.146-1.167a.932.932,0,0,1,1.331,0,.971.971,0,0,1,0,1.355l-1.146,1.166Zm-7.7.987H195.7a1.826,1.826,0,0,1-1.808-1.84v-5.62a.163.163,0,0,1,.161-.164h11.62a5.559,5.559,0,0,0-2.374,1.416,5.814,5.814,0,0,0-1.234,6.209Z",
    transform: "translate(-193.889 -476.173)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFailedPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_failed_payment.7e00b0c6e18d5b0cecc91e92ab624253.svg";